import _Vue from "vue";
import { Api } from "@/api";

export function EventHubPlugin(Vue: typeof _Vue): void {
    const eventHub = new Vue();
    (Vue as any).eventHub$ = eventHub;
    Vue.mixin({
        data: () => {
            return {
                eventHub$: eventHub
            };
        }
    });
}